import { apiClient } from './client';

export interface OrganizationStatistics {
  orgName: string;
  orgSlug: string;
  orgRefId?: string;
  orgActive: boolean;
  usersAmount: number;
  roomsAmount: number;
  surgeonsAmount: number;
  casesAmount: number;
  currentSync: boolean;
  lastSyncAt: string | null;
}

export interface KeyspaceDbInfo {
  keys: number;
  expires: number;
  avg_ttl: number;
}

export interface KeyspaceInfo {
  [key: string]: KeyspaceDbInfo;
}

export const adminApi = {
  getStatistics: () => apiClient.get<OrganizationStatistics[]>('/api/admin/statistics'),

  syncAll: (dir_name?: string) =>
    apiClient.post<{ status: string; message: string }>('/api/admin/sync-all', null, {
      params: dir_name ? { dir_name } : undefined,
    }),

  resyncAll: (dir_name?: string) =>
    apiClient.post<{ status: string; message: string }>('/api/admin/resync-all', null, {
      params: dir_name ? { dir_name } : undefined,
    }),

  resyncOne: (orgSlug: string) =>
    apiClient.post<{ status: string; message: string }>(`/api/admin/resync-one/${orgSlug}`),

  getCacheCountDb1: () =>
    apiClient.get<{ status: string; count: number }>('/api/admin/cache-count/db1'),

  getCacheCountDb2: () =>
    apiClient.get<{ status: string; count: number }>('/api/admin/cache-count/db2'),

  getKeyspaceInfo: () =>
    apiClient.get<{ status: string; keyspace: KeyspaceInfo }>('/api/admin/keyspace-info'),

  flushCacheDb1: () =>
    apiClient.post<{ status: string; message: string }>('/api/admin/flush-cache/db1'),

  flushCacheDb2: () =>
    apiClient.post<{ status: string; message: string }>('/api/admin/flush-cache/db2'),

  getRedisKeys: (dbNum: number, count = 20) =>
    apiClient.get<{ status: string; db: number; keys: string[]; count: number }>(
      `/api/admin/redis-keys/${dbNum}`,
      { params: { count } },
    ),

  deleteAllSchedules: (hospitalCode: string) =>
    apiClient.delete<{ status: string; message: string; deleted_count: number }>(
      `/api/admin/schedules/${hospitalCode}`,
    ),
};
